import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import { getJsonFromStorage, responseLogWithNotification, saveFilter } from '../../../utils/utils';
import { loadFilterTemplateList } from '../actions';
import { PAGE_TYPE_LIST } from './filter-settings';
import { renderFilter } from './renderUtils';
import { getFilterTemplateData } from '../reducer';

export default function FilterForm(props) {
  const {
    page,
    control,
  } = props;
  const name = `${page}-filter-options`;
  const valueName = `${page}-filter-value`;
  const dispatch = useDispatch();
  const [options, setOptions] = useState(getJsonFromStorage(name, []));
  const [selectedFilter, setSelectedFilter] = useState(getJsonFromStorage(valueName, null));
  const { loadingFilterTemplateList } = useSelector(getFilterTemplateData);

  const loadData = opts => {
    const requestData = {
      filter: { page },
    };
    dispatch(loadFilterTemplateList(requestData)).then(res => {
      if (res.data.length) {
        saveFilter(res.data, name);
        setOptions(res.data);
      }
    }).catch(responseLogWithNotification);
  };

  useEffect(() => { loadData(); }, []);
  const selectedPage = PAGE_TYPE_LIST.find(option => option.value === page);
  const defaultFilters = selectedPage.filter.map((group, key) => {
    group.enable = true;
    group.sortIndex = key;
    group?.children.map((c, key2) => {
      c.enable = true;
      c.sortIndex = key2;
      if (c?.options?.length) {
        c.options = c?.options.map(o => ({ ...o, enable: true }));
      }
      return c;
    });
    return group;
  });

  const template = options.find(item => item.id === selectedFilter);
  const filters = template?.filters || defaultFilters;
  return (
    <form className="filter-content-wrapper">
      <CustomSelectInput
        inputProps={{
          value: selectedFilter,
          onChange: e => {
            const id = e.target.value;
            setSelectedFilter(id);
            saveFilter(id, valueName);
          },
        }}
        label="Шаблон фильтра"
        withLabel
        options={options.map(item => ({ value: item.id, name: item.name }))}
        variant="material"
        isLoading={loadingFilterTemplateList}
        placeholder="Отображать все фильтры"
      />
      {renderFilter(filters, control, page)}
    </form>
  );
}
